// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1AgNA","content":"Consent_content__eVQjr","footer":"Consent_footer__5Vjzp"};